export default __webpack_public_path__ + "static/media/laporan-supplier.9c2e2c0c.png";